import React from "react";
import classes from "./Navigations.module.css";
import MyLink from "../../hoc/Link/Link";
const Navigations = (props) => {
  const links = [
    { name: "About", link: "", image: "" },
    { name: "Skills", link: "", image: "" },
    { name: "Projects", link: "", image: "" },
    { name: "Services", link: "", image: "" },
    { name: "Experience", link: "", image: "" },
    { name: "Contacts", link: "", image: "" },
  ].map((link) => {
    return (
      <MyLink
        key={link.name}
        to={link.name}
        name={link.name}
        click={props.click}
      ></MyLink>
    );
  });
  const headerClass = [props.CSSstyle, classes.HeaderNav].join(" ");
  return (
    <>
      <div className={headerClass}>
        {" "}
        {props.children}
        {links}
      </div>
    </>
  );
};

export default Navigations;
